<template>
  <InfomationDetail :info="info" />
</template>

<script>
import GlobalInfoService from "../../services/global-info.service";
import InfomationDetail from "@/components/InfomationDetail.vue";

export default {
  components: { InfomationDetail },
  name: "info-detail",
  data() {
    return {
      info: {
        target: "",
        target_user: "",
        title: "",
        body: "",
        kakomi: "",
        registration_at: "",
        display_range: { start: "", end: "" },
        url: "",
        url_target: false,
        url_title: "",
        label: "",
        is_top: false,
        is_schedule: false,
        calender_text: "",
        calender_range: { start: "", end: "" },
        is_dispTime: true,
        notification_mail: false,
        notification_push: false,
      },
    };
  },
  // async beforeRouteUpdate(to, from, next) {
  //   try {
  //     const response = await GlobalInfoService.findByID(to.params.id);
  //     console.log("response",response);
  //     if (response.data.length > 0) {
  //       this.info = response.data[0];
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     this.$router.push({
  //       name: "notfound404",
  //       params: { mc_code: this.currentUser.mansion._id },
  //     });
  //   }
  //   next();
  // },
  async mounted() {
    console.log("info datail +++ mounted");
    await this.$nextTick();
    try {
      const response = await GlobalInfoService.findByID(this.$route.params.id);
      console.log(response);
      if (response) {
        this.info = response;
        console.log(this.info);
      }
    } catch (error) {
      console.log(error);
      this.$router.push({
        name: "notfound404",
        params: { mc_code: this.currentUser.mansion._id },
      });
    }
  },
};
</script>

<style></style>
